import PropTypes from 'prop-types';

export const Calculations = PropTypes.shape({
    price: PropTypes.shape({
        fees: PropTypes.number,
        sendAmount: PropTypes.number.isRequired,
        sendCurrencyCode: PropTypes.string.isRequired
    }).isRequired
});

export const Translations = PropTypes.shape({
    formHeader: PropTypes.shape({
        payMethod: PropTypes.string.isRequired,
        payWithSavedCard: PropTypes.string.isRequired
    }).isRequired,
    zepz: PropTypes.shape({
        labels: PropTypes.shape({
            cardNumber: PropTypes.string.isRequired,
            expiryDate: PropTypes.string.isRequired,
            securityCode: PropTypes.string.isRequired
        }).isRequired,
        errors: PropTypes.shape({
            cardNumber: PropTypes.shape({
                required: PropTypes.string.isRequired,
                format: PropTypes.string.isRequired
            }).isRequired,
            expiryDate: PropTypes.shape({
                required: PropTypes.string.isRequired,
                format: PropTypes.string.isRequired,
                notInFuture: PropTypes.string.isRequired
            }).isRequired,
            securityCode: PropTypes.shape({
                required: PropTypes.string.isRequired,
                format: PropTypes.string.isRequired
            }).isRequired
        }).isRequired,
        cardNumberPlaceholder: PropTypes.string.isRequired,
        submitButton: PropTypes.string.isRequired,
        saveCardForFuture: PropTypes.string.isRequired
    }).isRequired,
    common: PropTypes.shape({
        cancel: PropTypes.string.isRequired,
        continue: PropTypes.string.isRequired
    }).isRequired,
    creditCard: PropTypes.shape({
        expires: PropTypes.string.isRequired,
        labelRemove: PropTypes.string.isRequired,
        confirmRemove: PropTypes.string.isRequired
    }).isRequired,
    cvvHelpInfo: PropTypes.shape({
        titleThreeDigits: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired
    }).isRequired
});

export const FormData = PropTypes.shape({
    timestamp: PropTypes.string.isRequired,
    authenticationKey: PropTypes.string.isRequired,
    tokenexId: PropTypes.string.isRequired,
    scheme: PropTypes.string.isRequired
});

export const Card = PropTypes.shape({
    id: PropTypes.string.isRequired,
    bin: PropTypes.string.isRequired,
    panSuffix: PropTypes.string.isRequired,
    cardHolderName: PropTypes.string.isRequired,
    expiry: PropTypes.shape({
        month: PropTypes.string.isRequired,
        year: PropTypes.string.isRequired
    }).isRequired,
    schema: PropTypes.string.isRequired,
    zepz: PropTypes.bool.isRequired
});


export default {
    Calculations,
    Translations,
    FormData,
    Card
};
